<template>
  <div class="uk-margin">
    <div v-if="infoloading">
      <v-progress-circular :width="2" indeterminate style="color: forestgreen"></v-progress-circular>
    </div>
    <div v-else>
      <template v-if="isEnableComment() && !education_pro_retoucher">
        <div class="uk-position-relative">
          <textarea
              v-model="comment"
              @focus="isTextareaFocused = true"
              @blur="isTextareaFocused = false"
              id="validatedComment"
              class="uk-textarea uk-height-small_" style="height: 330px;"></textarea>
          <label class="tm-form-label" v-if="!isTextareaFocused && !comment"  v-html="local_page_keys.proretoucher_comment_placeholder"></label>
        </div>
        <div class="uk-margin-top">
          <button type="button"
                  class="uk-button uk-button-success uk-width-1-1"
                  @click="submitComment">
            <md-icon class="uk-margin-small-right">mail</md-icon>
            {{ local_page_keys.button_send }}
          </button>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name: "CommentForRatingProRetoucher",
  props: {
    local_page_keys: {
      type: Object,
      require: true
    },
    order_id: {
      type: Number,
      require: true
    },
    order_chat: {
      // type: Array,
      require: true
    },
    infoloading: {
      type: Boolean,
      require: true,
    },
    order_senior_retoucher_quality: {
      type: String
    },
    education_pro_retoucher:{
      type: Boolean
    }
  },
  data: () => ({
    comment: '',
    isTextareaFocused: false
  }),
  methods: {
    async submitComment() {
      if (this.comment === null || this.comment.trim() === '') {
        let comment = document.querySelector('#validatedComment');
        comment.classList.add('tm-val-error');
        alert(this.local_page_keys.alert_problem_required);
        return;
      }

      let formData = new FormData();
      formData.append('order_id', this.order_id);
      formData.append('comment', this.comment);
      let data;
      try {
        await this.$store.dispatch("postProRetoucher/sendComment", {data: formData});
        data = await this.$store.getters['postProRetoucher/sendComment'];
        if (data.status === 'ok') {
          this.comment = '';
          //Обновление оценки в рейтинге
          this.$root.$emit('pro-retoucher-comment-chat', { 'order_id': this.order_id});
          this.$emit('reloadChat', true)
        } else {
          alert(data.message);
          this.$emit('reloadChat', true);
        }
      } catch (e) {
        this.$emit('reloadChat', true);
      }
    },
    isEnableComment() {
      let chat = Object.values(this.order_chat);
      let likesCount = chat.filter(item => item.like_by_client < 5).length;
      let redoClientCount = chat.filter(item => item.name === 'redo client').length;
      return likesCount > 0 || redoClientCount > 0 || this.order_senior_retoucher_quality === 'bad-job';
    }
  },
  computed: {},
  created() {
  },
}
</script>

<style>
  .uk-textarea:active + .tm-form-label,
  .uk-textarea:focus + .tm-form-label {
    opacity: 0;
    top: 0;
  }
  .tm-form-label {
    position: absolute;
    top: 10px;
    left: 10px;
    right: 10px;
    bottom: 10px;
    pointer-events: none;
    transition: .4s cubic-bezier(.25,.8,.25,1);
    transition-duration: .3s;
    font-size: 14px;
    line-height: 1.3;
    color: #8f8f8f;
  }
</style>